import {Component, OnInit} from '@angular/core';
import {UserNamespace} from '@namespaces/user.namespace';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {TechnicalDeviceElementGroupsPagesService} from '../../services/element-groups/technical-device-element-groups-pages.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';

@Component({
    selector: 'app-elements',
    templateUrl: 'elements-groups.component.html'
})

export class ElementsGroupsComponent extends ListItemsComponent<TechnicalDeviceElementGroupsPagesService> implements OnInit {

    public permissions = UserNamespace.Permission;

    public newUrl: string;

    constructor(
        service: TechnicalDeviceElementGroupsPagesService,
        private dataService: TechnicalDeviceDataService,
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();

        this.newUrl = RoutesStorage.ElementGroup.new(this.dataService.deviceId);
    }
}
